var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "reaction-overview" },
    [
      _vm.loading
        ? _c("div", { staticClass: "reaction-overview__state" }, [
            _vm._v("Sollicitatie laden…"),
          ])
        : _vm.errorMessage
        ? _c(
            "div",
            {
              staticClass:
                "reaction-overview__state reaction-overview__state--error",
            },
            [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n    ")]
          )
        : _vm.reaction
        ? _c(
            "div",
            { staticClass: "reaction-overview__container" },
            [
              _c(
                "router-link",
                {
                  staticClass: "reaction-overview__back",
                  attrs: {
                    to: {
                      name: "grid",
                      params: {
                        gridDefinition: "grid",
                        bundle: "reaction",
                      },
                    },
                  },
                },
                [
                  _c("i", { staticClass: "ak-icon" }, [_vm._v("west")]),
                  _vm._v("\n        Terug naar kandidaten\n      "),
                ]
              ),
              _vm._v(" "),
              _c("header", { staticClass: "reaction-overview__header" }, [
                _c("div", [
                  _c("h1", { staticClass: "reaction-overview__title" }, [
                    _vm._v(_vm._s(_vm.candidateName)),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "reaction-overview__subtitle" }, [
                    _vm._v("\n                    Solliciteerde voor "),
                    _c("strong", [_vm._v(_vm._s(_vm.job.title))]),
                    _vm._v(" "),
                    _vm.canChangeJob
                      ? _c(
                          "button",
                          {
                            staticClass: "reaction-overview__job-edit-button",
                            attrs: {
                              type: "button",
                              "aria-label": "Vacature wijzigen",
                              title: "Vacature wijzigen",
                            },
                            on: { click: _vm.editReactionJob },
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "ak-icon",
                                attrs: { "aria-hidden": "true" },
                              },
                              [_vm._v("edit")]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "reaction-overview__status-control" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "reaction-overview__status",
                        attrs: {
                          type: "button",
                          "aria-label": "Status en opvolging wijzigen",
                        },
                        on: { click: _vm.editReactionFollowUp },
                      },
                      [
                        _c("span", [_vm._v(_vm._s(_vm.status.title))]),
                        _vm._v(" "),
                        _c(
                          "i",
                          {
                            staticClass: "ak-icon",
                            attrs: { "aria-hidden": "true" },
                          },
                          [_vm._v("edit")]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.reaction.nextActionAt
                      ? _c(
                          "span",
                          {
                            staticClass: "reaction-overview__next-action",
                            class: {
                              "reaction-overview__next-action--required":
                                _vm.reaction.actionRequired,
                            },
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "ak-icon",
                                attrs: { "aria-hidden": "true" },
                              },
                              [_vm._v("event")]
                            ),
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.reaction.actionRequired
                                    ? "Actie vereist sinds"
                                    : "Volgende actie op"
                                ) +
                                "\n                    " +
                                _vm._s(_vm.reaction.nextActionAt) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "section",
                {
                  staticClass: "reaction-overview__tags",
                  attrs: { "aria-label": "Tags" },
                },
                [
                  _c(
                    "ul",
                    { staticClass: "reaction-overview__tag-list" },
                    [
                      _vm._l(_vm.tags, function (tag) {
                        return _c("li", { key: tag.id }, [
                          _c(
                            "span",
                            {
                              staticClass: "reaction-overview__tag",
                              style: {
                                backgroundColor: tag.color,
                                color: _vm.getTagTextColor(tag.color),
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(tag.title) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ])
                      }),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "button",
                          {
                            staticClass:
                              "reaction-overview__tag reaction-overview__tag--add",
                            attrs: { type: "button" },
                            on: { click: _vm.editReactionTags },
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "ak-icon",
                                attrs: { "aria-hidden": "true" },
                              },
                              [_vm._v("add")]
                            ),
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.tags.length
                                    ? "Tags bewerken"
                                    : "Tags toevoegen"
                                ) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]),
                    ],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "reaction-overview__grid" }, [
                _c(
                  "section",
                  {
                    staticClass:
                      "reaction-overview__card reaction-overview__card--message",
                    attrs: { "aria-labelledby": "application-title" },
                  },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "dl",
                      {
                        staticClass:
                          "reaction-overview__details-list reaction-overview__details-list--on-dark",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "reaction-overview__detail" },
                          [
                            _c("dt", [_vm._v("Referentienummer")]),
                            _vm._v(" "),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.reaction.referenceNumber || "-")
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "reaction-overview__detail" },
                          [
                            _c("dt", [_vm._v("Ontvangen op")]),
                            _vm._v(" "),
                            _c("dd", [
                              _vm._v(_vm._s(_vm.reaction.createdAt || "-")),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "reaction-overview__detail" },
                          [
                            _c("dt", [_vm._v("Volgende actie")]),
                            _vm._v(" "),
                            _c("dd", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.reaction.nextActionAt ||
                                      "Niet ingepland"
                                  ) +
                                  "\n                            "
                              ),
                              _vm.reaction.actionRequired
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "reaction-overview__action-required",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                Actie vereist\n                            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "reaction-overview__detail" },
                          [
                            _c("dt", [_vm._v("Kandidaat")]),
                            _vm._v(" "),
                            _c("dd", [_vm._v(_vm._s(_vm.candidateName))]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.scoreCriteria, function (scoreCriterion) {
                          return _c(
                            "div",
                            {
                              key: scoreCriterion.key,
                              staticClass: "reaction-overview__detail",
                            },
                            [
                              _c("dt", [_vm._v(_vm._s(scoreCriterion.label))]),
                              _vm._v(" "),
                              _c("dd", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "reaction-overview__score-control",
                                    attrs: {
                                      role: "group",
                                      "aria-label": `${scoreCriterion.label} voor deze sollicitatie`,
                                    },
                                  },
                                  _vm._l(_vm.scoreOptions, function (score) {
                                    return _c(
                                      "button",
                                      {
                                        key: score,
                                        staticClass:
                                          "reaction-overview__score-button",
                                        class: {
                                          "reaction-overview__score-button--active":
                                            _vm.reaction[scoreCriterion.key] ===
                                            score,
                                        },
                                        attrs: {
                                          type: "button",
                                          disabled:
                                            _vm.isUpdatingScore[
                                              scoreCriterion.key
                                            ],
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.updateScore(
                                              scoreCriterion.key,
                                              score
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(score) +
                                            "\n                                "
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "reaction-overview__score-value",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.reaction[scoreCriterion.key] ===
                                            null
                                            ? "Nog niet beoordeeld"
                                            : `${
                                                _vm.reaction[scoreCriterion.key]
                                              }/10`
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.scoreErrorMessages[scoreCriterion.key]
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "reaction-overview__score-error",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.scoreErrorMessages[
                                                scoreCriterion.key
                                              ]
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "reaction-overview__detail" },
                          [
                            _c("dt", [_vm._v("Afgerond op")]),
                            _vm._v(" "),
                            _c("dd", [
                              _vm._v(_vm._s(_vm.reaction.completedAt || "-")),
                            ]),
                          ]
                        ),
                      ],
                      2
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "aside",
                  {
                    staticClass:
                      "reaction-overview__card reaction-overview__card--details",
                    attrs: { "aria-labelledby": "details-title" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "reaction-overview__section-heading" },
                      [
                        _c("p", { staticClass: "reaction-overview__eyebrow" }, [
                          _vm._v("Contact"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "reaction-overview__section-title" },
                          [
                            _c("h2", { attrs: { id: "details-title" } }, [
                              _vm._v("Gegevens"),
                            ]),
                            _vm._v(" "),
                            _vm.candidate.isInternalCandidate
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "reaction-overview__internal-label",
                                  },
                                  [_vm._v("Interne kandidaat")]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "dl",
                      { staticClass: "reaction-overview__details-list" },
                      _vm._l(_vm.contactDetails, function (detail) {
                        return _c(
                          "div",
                          {
                            key: detail.label,
                            staticClass: "reaction-overview__detail",
                          },
                          [
                            _c("dt", [_vm._v(_vm._s(detail.label))]),
                            _vm._v(" "),
                            _c(
                              "dd",
                              [
                                detail.href
                                  ? _c("a", { attrs: { href: detail.href } }, [
                                      _vm._v(_vm._s(detail.value)),
                                    ])
                                  : [_vm._v(_vm._s(detail.value))],
                              ],
                              2
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "section",
                  {
                    staticClass:
                      "reaction-overview__card reaction-overview__card--documents",
                    attrs: { "aria-labelledby": "documents-title" },
                  },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm.documentGroups.length
                      ? _c(
                          "dl",
                          {
                            staticClass: "reaction-overview__document-groups",
                            attrs: { "aria-labelledby": "documents-title" },
                          },
                          _vm._l(_vm.documentGroups, function (group) {
                            return _c(
                              "div",
                              {
                                key: group.type,
                                staticClass:
                                  "reaction-overview__detail reaction-overview__document-group",
                              },
                              [
                                _c("dt", [_vm._v(_vm._s(group.label))]),
                                _vm._v(" "),
                                _c("dd", [
                                  _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "reaction-overview__document-list",
                                    },
                                    _vm._l(
                                      group.documents,
                                      function (document) {
                                        return _c(
                                          "li",
                                          {
                                            key: document.downloadLink,
                                            staticClass:
                                              "reaction-overview__document-list-item",
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "reaction-overview__document-name",
                                                attrs: {
                                                  href: document.downloadLink,
                                                  target: "_blank",
                                                  rel: "noopener",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      document.filenameOriginal
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass: "ak-icon",
                                                    attrs: {
                                                      "aria-hidden": "true",
                                                    },
                                                  },
                                                  [_vm._v("download")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                              ]
                            )
                          }),
                          0
                        )
                      : _c("p", { staticClass: "reaction-overview__empty" }, [
                          _vm._v("Geen documenten beschikbaar."),
                        ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "section",
                  {
                    staticClass:
                      "reaction-overview__card reaction-overview__card--remarks",
                    attrs: { "aria-labelledby": "remarks-title" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "reaction-overview__section-heading reaction-overview__section-heading--with-action",
                      },
                      [
                        _vm._m(2),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "reaction-overview__remark-add-button",
                            attrs: { type: "button" },
                            on: { click: _vm.addReactionRemark },
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "ak-icon",
                                attrs: { "aria-hidden": "true" },
                              },
                              [_vm._v("add")]
                            ),
                            _vm._v(
                              "\n                        Opmerking / verslag toevoegen\n                    "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ol",
                      { staticClass: "reaction-overview__remarks" },
                      [
                        _vm._l(_vm.internalRemarks, function (remark, index) {
                          return _c(
                            "li",
                            {
                              key: remark.id || index,
                              staticClass: "reaction-overview__remark",
                            },
                            [
                              _c(
                                "header",
                                {
                                  staticClass:
                                    "reaction-overview__remark-header",
                                },
                                [
                                  _c("div", [
                                    _c("h3", [
                                      _vm._v(
                                        _vm._s(
                                          remark.title || "Interne opmerking"
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      remark.cmsUser
                                        ? _c("span", [
                                            _vm._v(_vm._s(remark.cmsUser.name)),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      remark.cmsUser && remark.createdAt
                                        ? _c(
                                            "span",
                                            {
                                              attrs: { "aria-hidden": "true" },
                                            },
                                            [_vm._v(" · ")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            remark.createdAt || "Datum onbekend"
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  remark.statusUpdate
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "reaction-overview__remark-actions",
                                        },
                                        [
                                          remark.statusUpdate
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "reaction-overview__remark-status-update",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "reaction-overview__remark-status",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          remark.statusUpdate
                                                            .from
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass: "ak-icon",
                                                      attrs: {
                                                        "aria-hidden": "true",
                                                      },
                                                    },
                                                    [_vm._v("arrow_forward")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "reaction-overview__remark-status",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          remark.statusUpdate.to
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "reaction-overview__remark-content",
                                domProps: { innerHTML: _vm._s(remark.remark) },
                              }),
                              _vm._v(" "),
                              remark.documents && remark.documents.length
                                ? _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "reaction-overview__remark-documents",
                                    },
                                    _vm._l(
                                      remark.documents,
                                      function (document) {
                                        return _c(
                                          "li",
                                          { key: document.downloadLink },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "reaction-overview__remark-document",
                                                attrs: {
                                                  href: document.downloadLink,
                                                  target: "_blank",
                                                  rel: "noopener",
                                                },
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "ak-icon reaction-overview__remark-icon",
                                                    attrs: {
                                                      "aria-hidden": "true",
                                                    },
                                                  },
                                                  [_vm._v("description")]
                                                ),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      document.filenameOriginal
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass: "ak-icon",
                                                    attrs: {
                                                      "aria-hidden": "true",
                                                    },
                                                  },
                                                  [_vm._v("download")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        !_vm.internalRemarks.length
                          ? _c(
                              "li",
                              { staticClass: "reaction-overview__empty" },
                              [
                                _vm._v(
                                  "\n                        Nog geen interne opmerkingen of contactverslagen toegevoegd.\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "section",
                  {
                    staticClass:
                      "reaction-mail-overview reaction-overview__card",
                    attrs: { "aria-labelledby": "mails-title" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "reaction-overview__section-heading reaction-overview__section-heading--with-action",
                      },
                      [
                        _vm._m(3),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "reaction-overview__remark-add-button",
                            attrs: { type: "button" },
                            on: { click: _vm.addReactionMail },
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "ak-icon",
                                attrs: { "aria-hidden": "true" },
                              },
                              [_vm._v("add")]
                            ),
                            _vm._v(
                              "\n                        Nieuwe mail opstellen\n                    "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.mails.length
                      ? _c(
                          "div",
                          { staticClass: "reaction-mail-overview__table-wrap" },
                          [
                            _c(
                              "table",
                              { staticClass: "reaction-mail-overview__table" },
                              [
                                _c("caption", [
                                  _vm._v(
                                    "Overzicht van inkomende en uitgaande e-mails"
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._m(4),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  _vm._l(_vm.mails, function (mail) {
                                    return _c("tr", { key: mail.id }, [
                                      _c("td", [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "reaction-mail-overview__direction",
                                            class: `reaction-mail-overview__direction--${mail.direction}`,
                                          },
                                          [
                                            _c(
                                              "i",
                                              {
                                                staticClass: "ak-icon",
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      mail.direction ===
                                                        "incoming"
                                                        ? "south_west"
                                                        : "north_east"
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  mail.direction === "incoming"
                                                    ? "In"
                                                    : "Uit"
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c("time", [
                                          _vm._v(_vm._s(mail.createdAt || "-")),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "reaction-mail-overview__subject",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              mail.subject || "Zonder onderwerp"
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "reaction-mail-overview__summary",
                                        },
                                        [_vm._v(_vm._s(mail.summary || "-"))]
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        mail.attachments.length
                                          ? _c(
                                              "ul",
                                              {
                                                staticClass:
                                                  "reaction-mail-overview__attachments",
                                              },
                                              _vm._l(
                                                mail.attachments,
                                                function (attachment) {
                                                  return _c(
                                                    "li",
                                                    {
                                                      key: attachment.downloadLink,
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: attachment.downloadLink,
                                                            target: "_blank",
                                                            rel: "noopener",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "i",
                                                            {
                                                              staticClass:
                                                                "ak-icon",
                                                              attrs: {
                                                                "aria-hidden":
                                                                  "true",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "attach_file"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                attachment.filenameOriginal
                                                              )
                                                            ),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "i",
                                                            {
                                                              staticClass:
                                                                "ak-icon",
                                                              attrs: {
                                                                "aria-hidden":
                                                                  "true",
                                                              },
                                                            },
                                                            [_vm._v("download")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "reaction-mail-overview__no-attachments",
                                              },
                                              [_vm._v("-")]
                                            ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "reaction-mail-overview__follow-up",
                                        },
                                        [
                                          mail.direction === "incoming"
                                            ? [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "reaction-mail-overview__process-button",
                                                    attrs: {
                                                      type: "button",
                                                      disabled:
                                                        mail.isProcessed ||
                                                        _vm.isMailProcessing(
                                                          mail
                                                        ),
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.markMailProcessed(
                                                          mail
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.isMailProcessing(
                                                            mail
                                                          )
                                                            ? "Bezig…"
                                                            : mail.isProcessed
                                                            ? "Verwerkt"
                                                            : "Markeer als verwerkt"
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                mail.processingError
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "reaction-mail-overview__process-error",
                                                        attrs: {
                                                          role: "alert",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              mail.processingError
                                                            ) +
                                                            "\n                                        "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "reaction-mail-overview__no-follow-up",
                                                },
                                                [_vm._v("-")]
                                              ),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "reaction-mail-overview__actions",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "reaction-mail-overview__view-button",
                                              attrs: { type: "button" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.viewReactionMail(
                                                    mail
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        Bekijken\n                                        "
                                              ),
                                              _c(
                                                "i",
                                                {
                                                  staticClass: "ak-icon",
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                  },
                                                },
                                                [_vm._v("chevron_right")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ])
                                  }),
                                  0
                                ),
                              ]
                            ),
                          ]
                        )
                      : _c("p", { staticClass: "reaction-overview__empty" }, [
                          _vm._v(
                            "\n                    Nog geen inkomende of uitgaande e-mails beschikbaar.\n                "
                          ),
                        ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "section",
                  {
                    staticClass:
                      "reaction-overview__card reaction-overview__card--timeline",
                    attrs: { "aria-labelledby": "timeline-title" },
                  },
                  [
                    _vm._m(5),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "reaction-overview__timeline" },
                      [
                        _vm._l(_vm.logs, function (log, index) {
                          return _c(
                            "li",
                            {
                              key: `${log.createdAt}-${index}`,
                              staticClass: "reaction-overview__timeline-item",
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(log.createdAt || "-")),
                              ]),
                              _vm._v(" "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    log.description || "Sollicitatie bijgewerkt"
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              log.cmsUser
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "reaction-overview__timeline-user",
                                    },
                                    [
                                      _c(
                                        "i",
                                        {
                                          staticClass: "ak-icon",
                                          attrs: { "aria-hidden": "true" },
                                        },
                                        [_vm._v("person")]
                                      ),
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(log.cmsUser.name) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        !_vm.logs.length
                          ? _c(
                              "li",
                              { staticClass: "reaction-overview__empty" },
                              [_vm._v("Nog geen historiek beschikbaar.")]
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("router-view", {
        attrs: { name: "childview" },
        on: { reactionSaved: _vm.reactionSaved },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "reaction-overview__section-heading" }, [
      _c("p", { staticClass: "reaction-overview__eyebrow" }, [
        _vm._v("Sollicitatie"),
      ]),
      _vm._v(" "),
      _c("h2", { attrs: { id: "application-title" } }, [
        _vm._v("Over deze kandidatuur"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "reaction-overview__section-heading" }, [
      _c("p", { staticClass: "reaction-overview__eyebrow" }, [
        _vm._v("Bestanden"),
      ]),
      _vm._v(" "),
      _c("h2", { attrs: { id: "documents-title" } }, [_vm._v("Documenten")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticClass: "reaction-overview__eyebrow" }, [
        _vm._v("Intern"),
      ]),
      _vm._v(" "),
      _c("h2", { attrs: { id: "remarks-title" } }, [
        _vm._v("Opmerkingen en contactverslagen"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticClass: "reaction-overview__eyebrow" }, [
        _vm._v("Communicatie"),
      ]),
      _vm._v(" "),
      _c("h2", { attrs: { id: "mails-title" } }, [_vm._v("E-mails")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("In/uit")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Datum")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Onderwerp")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Bericht")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Bijlagen")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Opvolging")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [
          _c(
            "span",
            { staticClass: "reaction-mail-overview__visually-hidden" },
            [_vm._v("Acties")]
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "reaction-overview__section-heading" }, [
      _c("p", { staticClass: "reaction-overview__eyebrow" }, [
        _vm._v("Overzicht"),
      ]),
      _vm._v(" "),
      _c("h2", { attrs: { id: "timeline-title" } }, [_vm._v("Historiek")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }